module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mcl-wrapper"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.filterText
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "focus": function($event) {
        $event.target.select()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "input-group-addon glyphicon glyphicon-filter",
    staticStyle: {
      "top": "0"
    }
  })]), _c('div', {
    staticClass: "mcl-items",
    style: (_vm.minHeight ? {
      'min-height': _vm.minHeight + 'px'
    } : {})
  }, [(_vm.displayedData && !_vm.loading) ? _c('span', [_c('virtualList', {
    attrs: {
      "size": 38,
      "remain": 5,
      "onscroll": _vm.loadMore,
      "bench": 40
    }
  }, [(_vm.allowSelectAll && !_vm.disabled) ? _c('div', {
    staticClass: "checkbox text-left"
  }, [_c('label', {
    staticClass: "to-click select-all"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectVisible),
      expression: "selectVisible"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectVisible) ? _vm._i(_vm.selectVisible, null) > -1 : (_vm.selectVisible)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.selectVisible,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectVisible = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectVisible = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectVisible = $$c
        }
      }
    }
  }), _c('span', [_vm._v("Selecionar todos visíveis")])])]) : _vm._e(), _vm._l((_vm.displayedData), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "checkbox text-left"
    }, [_c('MultiItemSelector', {
      attrs: {
        "useState": _vm.useState,
        "item": item,
        "uniqueKey": _vm.uniqueKey,
        "disabled": _vm.disabled,
        "formatName": _vm.formatName,
        "clickItem": _vm.clickItem
      }
    })], 1)
  }), (_vm.loading) ? _c('div', _vm._l(([1, 2, 3, 4, 5]), function(i) {
    return _c('div', {
      staticClass: "loading-bars",
      style: ({
        'width': Math.random() * (70 - 35) + 35 + '%'
      })
    }, [_vm._v(" ")])
  })) : _vm._e()], 2)], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3786505b"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=jade!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/MultiSelect/MultiSelect.vue
// module id = 309
// module chunks = 2